//개발서버
//export const API_URL = "http://dev1.kck.kr:3001";
//export const WEB_Site_URL = "http://dev1.kck.kr:8080";

//실시버
export const API_URL = "https://doc.kck.kr";
export const WEB_Site_URL = "https://doc.kck.kr";


